import { LoadingOutlined } from "@ant-design/icons";
import { Checkbox, notification, Select, Spin } from "antd";
import MultiInputField from "components/common/MultiInputField";
import MultiSelectWithRepeat from "components/common/MultiSelectWithRepeat";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";

import AccessControl from "../../../components/common/AccessControl/accessControl";
import CloseModal from "../../../components/icons/CloseModal";
import {
  awsRegions,
  bitRateModes,
  mediaLiveInput,
  mediaLiveTemplateOption,
  mediaLiveTemplateRegions,
  mediaStaticInput,
  streamingType,
} from "../../../config";
import {
  backupInputTypes,
  multiAudioOptions,
  PROGRAM_DATE_TIME,
  pushStreamInputTypes,
  reservedChannelInputType,
} from "../../../constants/phase";
import { editTemplateValidation } from "../../../utils/validations";

const { Option } = Select;
const EditMediaLiveTemplate = (props) => {
  const {
    setEditOpen,
    editOpen,
    template,
    storageDetail,
    editMediaTemplate,
    setLoder,
    loder,
    notify,
    setNotify,
    getMediaTemplates,
    reservedChannel,
    entityId,
    templateConfigData,
  } = props;
  const [initialValues, setInitialValues] = useState({
    templateName: "",
    height: "",
    width: "",
    bitRateMode: "CBR",
    bitrate: "",
    fps: "",
    outputTemplateType: "",
    outputRegion: "",
    inputType: "",
    streamingType: "live_to_vod",
    mediaLiveRegion: undefined,
    mediaLiveStorageId: "",
    isMultiAudio: false,
    isSRTPassword: false,
    reservedChannels: [],
    iso: "",
    pid: [],
    languages: [],
    track: [],
    fpsMode: "",
    fillMultiAudioWithStream: true,
    multiAudioOption: "iso",
    fileType: "",
    programDateTime: PROGRAM_DATE_TIME.INCLUDE,
    streamSelectionBitrateEnable: false,
    streamSelectionBitrate: 0,
    isBackup: false,
  });
  const [multiAudioOption, setMultiAudioOption] = useState("");

  const [selectedChannel, setSelectedChannel] = useState([]);
  const [selectedAudioOptions, setSelectedAudioOptions] = useState([]);
  const [selectedPids, setSelectedPids] = useState([]);
  const [inputType, setInputType] = useState("");
  const [filteredReservedChannels, setFilteredReservedChannels] = useState([]);
  const [selectedTracks, setSelectedTracks] = useState([]);

  const [minBitrateError, setMinBitrateError] = useState(false);
  const [bitRate, setBitRate] = useState("");
  useEffect(() => {
    if (template) {
      setInitialValues({
        templateName: template?.templateName,
        height: template?.height,
        width: template?.width,
        bitRateMode: template?.bitRateMode,
        bitrate: template?.bitrate,
        fpsMode: template?.fps === "INITIALIZE_FROM_SOURCE" ? "dynamic" : "static",
        fps: template?.fps === "INITIALIZE_FROM_SOURCE" ? 24 : template?.fps,
        outputTemplateType: template?.outputTemplateType,
        outputRegion: template?.outputRegion,
        inputType: template?.input_type,
        streamingType: template?.streaming_mode,
        mediaLiveRegion: template?.region,
        mediaLiveStorageId: template?.mediaLiveStorageId,
        reservedChannels: template?.reservedChannels,
        isMultiAudio: template?.isMultiAudio,
        isSRTPassword: template?.isSRTPassword,
        fillMultiAudioWithStream: template?.fillMultiAudioWithStream,
        languages: template?.multi_audio_type === "iso" ? template?.multi_audios : [],
        multiAudioOption: template?.multi_audio_type,
        pid: template?.multi_audio_type === "pid" ? template?.multi_audios : [],
        track: template?.multi_audio_type === "track" ? template?.multi_audios : [],
        fileType: template?.file_type === "" ? undefined : template?.file_type,
        programDateTime: template?.program_date_time,
        streamSelectionBitrateEnable: template?.streamSelectionBitrateEnable,
        streamSelectionBitrate: template?.streamSelectionBitrate,
        isBackup: template?.isBackup,
      });
      setSelectedChannel(template?.reservedChannels);
      setMultiAudioOption(template?.multi_audio_type);
      setInputType(template?.input_type);
      if (multiAudioOption === "iso") {
        setSelectedAudioOptions(
          template?.multi_audios.map((audio) => {
            const existingLabel = multiAudioOptions.find((aud) => aud["alpha3-b"] === audio);
            return {
              label: existingLabel !== undefined ? existingLabel?.English : audio,
              value: audio,
            };
          }),
        );
      } else if (multiAudioOption === "pid") {
        setSelectedPids(template?.multi_audios);
      } else if (multiAudioOption === "track") {
        setSelectedTracks(template?.multi_audios);
      }
    }
  }, [template, editOpen]);

  useEffect(() => {
    setFilteredReservedChannels(
      reservedChannel
        .filter((channel) => channel.inputType !== undefined && channel.inputType === inputType)
        .map((channel) => {
          return { label: channel?.channelName, value: channel?._id };
        }),
    );
  }, [inputType]);
  const handleChannelChange = (e) => {
    setSelectedChannel(e);
  };
  const closeModal = () => {
    setEditOpen(false);
    setNotify(false);
    setSelectedChannel(initialValues?.reservedChannel);
    setSelectedPids([]);
    setSelectedAudioOptions([]);
    setMultiAudioOption("");
  };
  const handlChange = (setFieldValue, e) => {
    if (e?.target?.name) {
      setFieldValue(e.target.name, e.target.value);
    }
    setNotify(false);
  };
  const handleSubmit = async (values) => {
    // setLoder(true);

    const payload = {
      _id: template?._id,
      templateName: values?.templateName,
      fps: values?.fpsMode === "static" ? values?.fps : "INITIALIZE_FROM_SOURCE",
      bitRateMode: values?.bitRateMode,
      bitrate: values?.bitrate,
      outputTemplateType: values?.outputTemplateType,
      outputRegion: values?.outputRegion,
      height: values?.height,
      width: values?.width,
      reservedChannels: values?.outputTemplateType == "reserved_channel" ? values?.reservedChannels : undefined,
      mediaLiveStorageId: ["medialive", "direct", "reserved_channel"].includes(values?.outputTemplateType)
        ? values?.mediaLiveStorageId
        : undefined,
      input_type:
        values?.outputTemplateType === "medialive" || values?.outputTemplateType === "reserved_channel"
          ? values?.inputType
          : undefined,
      streaming_mode: values?.inputType === "URL_PULL" ? values.streamingType : "live_to_vod",
      region: values?.outputTemplateType == "medialive" ? values?.mediaLiveRegion : undefined,
      isSRTPassword:
        values?.isSRTPassword !== undefined
          ? values?.outputTemplateType === "medialive" && values?.inputType === "SRT_PULL"
            ? values?.isSRTPassword
            : false
          : undefined,
      isMultiAudio: values?.isMultiAudio,
      entityId,
      file_type: values?.fileType,
      program_date_time: values?.programDateTime,
      streamSelectionBitrateEnable: values?.streamSelectionBitrateEnable,
      streamSelectionBitrate: values?.streamSelectionBitrate,
      isBackup: values?.isBackup,
    };
    if (values?.isMultiAudio) {
      payload.fillMultiAudioWithStream = values?.fillMultiAudioWithStream;
      payload.multi_audio_type = multiAudioOption;
      payload.multi_audios =
        multiAudioOption === "iso"
          ? selectedAudioOptions.map((audio) => audio.value)
          : multiAudioOption === "track"
            ? values?.track
            : values?.pid;
    }
    const { value } = await editMediaTemplate(payload);
    if (value.success) {
      notification["success"]({ message: value.message });
      setNotify(false);
      closeModal();
    } else if (
      value.success == false &&
      value.message == `Template already exists with name: ${values?.templateName}`
    ) {
      setNotify(true);
    } else {
      notification["error"]({ message: value.message });
      closeModal();
    }
    getMediaTemplates();
    setLoder(false);
  };
  useEffect(() => {
    if (parseInt(bitRate) < parseInt(templateConfigData?.minBitrate)) {
      setMinBitrateError(true);
    } else {
      setMinBitrateError(false);
    }
  }, [bitRate]);
  const handleSelectChange = (value) => {
    setMultiAudioOption(value);
    setSelectedTracks([]);
  };

  const handleFPSModeChange = (value, values, setFieldValue) => {
    setFieldValue("fpsMode", value);
    if (value === "dynamic" && values.fps === "") {
      setFieldValue("fps", 24);
    }
  };
  const filterInputTypes = (option, templateType) => {
    return (
      (templateType === "medialive" && !["RTMP_PUSH", "SRT_PUSH"].includes(option.value)) ||
      (templateType === "reserved_channel" && [...reservedChannelInputType].includes(option.value)) ||
      templateType === "direct"
    );
  };
  const handleReservedChannels = (setFieldValue, value, values) => {
    if (!value || value.length === 0) {
      setFieldValue("reservedChannels", []);
      return;
    }
    if (pushStreamInputTypes.includes(values?.inputType)) {
      // Check if any selected item has `is_domain` set to true
      if (values?.reservedChannels?.length > 0) {
        notification["error"]({
          message: "In case of RTMP/SRT PUSH, only a single reserved channel can be added to one template.",
        });
        return; // Prevent adding another channel
      }

      // If selection is compatible, proceed with setting the filtered value
      setFieldValue("reservedChannels", value);
    } else {
      // For non-RTMP input types, set the value directly
      setFieldValue("reservedChannels", value);
    }
  };
  return (
    <>
      <Modal
        isOpen={editOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        ariaHideApp={false}
        className="modal-dialog react-modal-dialog-xm modal-dialog-centered"
      >
        <div className="modal-content">
          <AccessControl code="output_video_template" page="configuration">
            <div className="react-modal-header">
              <h5 className="react-modal-title">Edit template</h5>
              <button type="button" onClick={closeModal} className="btn btn__default">
                <CloseModal />
              </button>
            </div>
          </AccessControl>
          <Formik initialValues={initialValues} validationSchema={editTemplateValidation} onSubmit={handleSubmit}>
            {({ errors, touched, setFieldValue, values }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="form-group">
                      <label className="form-label">
                        Template Name <span className="required">*</span>
                      </label>
                      <Field
                        className="form-control"
                        name="templateName"
                        type="text"
                        placeholder="Enter Name"
                        value={values.templateName}
                        onChange={(e) => handlChange(setFieldValue, e)}
                      />
                      {notify && <div className="invalid-feedback">Template name already exists!</div>}
                      {touched.templateName && errors.templateName && (
                        <div className="invalid-feedback">{errors.templateName}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Height <span className="required">*</span>
                      </label>
                      <Field className="form-control" name="height" type="text" placeholder="Enter Height" />
                      {touched.height && errors.height && <div className="invalid-feedback">{errors.height}</div>}
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Width <span className="required">*</span>
                      </label>
                      <Field className="form-control" name="width" type="text" placeholder="Enter Width" />
                      {touched.width && errors.width && <div className="invalid-feedback">{errors.width}</div>}
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Bit Rate Mode <span className="required">*</span>
                      </label>
                      <Field
                        className="custom-ant-select"
                        optionFilterProp="children"
                        name="bitRateMode"
                        component={Select}
                        options={bitRateModes}
                        onChange={(value) => setFieldValue("bitRateMode", value)}
                        value={values?.bitRateMode}
                        defaultValue={values?.bitRateMode}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Bitrate <span className="required">*</span>
                      </label>
                      <Field
                        className="form-control"
                        name="bitrate"
                        type="text"
                        value={values?.bitrate}
                        onChange={(event) => {
                          setFieldValue("bitrate", event.target.value);
                          setBitRate(event.target.value);
                        }}
                        placeholder="Enter Bitrate"
                      />
                      {touched.bitrate && errors.bitrate && <div className="invalid-feedback">{errors.bitrate}</div>}
                      {touched.bitrate && minBitrateError && (
                        <div className="invalid-feedback">{`Minimum bitrate should be ${templateConfigData?.minBitrate}`}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        FPS Mode <span className="required">*</span>
                      </label>
                      <Field
                        className="custom-ant-select"
                        name="fpsMode"
                        onChange={(value) => handleFPSModeChange(value, values, setFieldValue)}
                        component={Select}
                        dropdownStyle={{ zIndex: 99999999 }}
                        defaultValue={initialValues?.fpsMode}
                      >
                        <Option value="static">Static</Option>
                        <Option value="dynamic">Dynamic</Option>
                      </Field>
                      {touched.fpsMode && errors.fpsMode && <div className="invalid-feedback">{errors.fpsMode}</div>}
                    </div>
                    {values.fpsMode === "static" ? (
                      <div className="form-group">
                        <label className="form-label">
                          FPS <span className="required">*</span>
                        </label>
                        <Field className="form-control" name="fps" type="text" placeholder="Enter FPS" />
                        {touched.fps && errors.fps && <div className="invalid-feedback">{errors.fps}</div>}
                      </div>
                    ) : null}
                    <div className="form-group">
                      <label className="form-label">
                        Output Media Type <span className="required">*</span>
                      </label>
                      <Field
                        className="custom-ant-select"
                        name="outputTemplateType"
                        showSearch
                        onChange={(value) => {
                          setFieldValue("outputTemplateType", value);
                          setFieldValue("reservedChannels", []);
                          setFieldValue("inputType", "");
                          setFieldValue("streamingType", "live_to_vod");
                          setInputType("");
                          setFieldValue("fileType", undefined);
                        }}
                        component={Select}
                        defaultValue={initialValues?.outputTemplateType}
                      >
                        {mediaLiveTemplateOption.length &&
                          mediaLiveTemplateOption.map((data, index) => {
                            return (
                              <>
                                <Option key={index} value={data.value}>
                                  {data.label}
                                </Option>
                              </>
                            );
                          })}
                      </Field>
                      {touched.outputTemplateType && errors.outputTemplateType && (
                        <div className="invalid-feedback">{errors.outputTemplateType}</div>
                      )}
                    </div>

                    {values?.outputTemplateType === "medialive" && (
                      <div className="form-group">
                        <label className="form-label">
                          File Type <span className="required">*</span>
                        </label>
                        <Field
                          className="custom-ant-select"
                          name="fileTYpe"
                          onChange={(value) => {
                            setFieldValue("fileType", value);
                            setFieldValue("inputType", "");
                            if (value === "static") {
                              setFieldValue("mediaLiveRegion", "ap-south-1");
                              setFieldValue("isMultiAudio", false);
                              setFieldValue("outputRegion", "asia");
                            }
                          }}
                          value={values?.fileType}
                          component={Select}
                          dropdownStyle={{ zIndex: 99999999 }}
                          defaultValue={"Select File Type Option"}
                        >
                          <Option value="static">Static</Option>
                          <Option value="live">Live</Option>
                        </Field>
                        {touched.fileType && errors.fileType && (
                          <div className="invalid-feedback">{errors.fileType}</div>
                        )}
                      </div>
                    )}
                    {((values?.outputTemplateType === "medialive" && values?.fileType !== "") ||
                      values?.outputTemplateType === "reserved_channel") && (
                      <div className="form-group">
                        <label className="form-label">
                          Input Type <span className="required">*</span>
                        </label>
                        <Field
                          className="custom-ant-select"
                          name="inputType"
                          showSearch
                          value={values?.inputType || "Select Input Type"}
                          onChange={(value) => {
                            setFieldValue("inputType", value);
                            setInputType(value);
                            setFieldValue("reservedChannels", []);
                            setFieldValue("streamingType", "live_to_vod");
                            setFieldValue("streamSelectionBitrateEnable", false);
                            setFieldValue("streamSelectionBitrate", 0);
                            setFieldValue("isBackup", false);
                          }}
                          component={Select}
                          dropdownStyle={{ zIndex: 99999999 }}
                        >
                          {values?.fileType === "static"
                            ? mediaStaticInput.map((data, index) => {
                                return (
                                  <Option key={index} value={data.value}>
                                    {data.label}
                                  </Option>
                                );
                              })
                            : mediaLiveInput.map((data, index) => {
                                return filterInputTypes(data, values?.outputTemplateType) ? (
                                  <Option key={index} value={data.value}>
                                    {data.label}
                                  </Option>
                                ) : (
                                  <></>
                                );
                              })}
                        </Field>
                        {touched.inputType && errors.inputType && (
                          <div className="invalid-feedback">{errors.inputType}</div>
                        )}
                      </div>
                    )}

                    {values.inputType === "URL_PULL" && (
                      <div className="form-group">
                        <label className="form-label">
                          Streaming Type <span className="required">*</span>
                        </label>
                        <Field
                          className="custom-ant-select"
                          optionFilterProp="children"
                          name="streamingType"
                          component={Select}
                          options={streamingType}
                          onChange={(value) => setFieldValue("streamingType", value)}
                          value={values?.streamingType}
                          defaultValue={values?.streamingType}
                        />
                      </div>
                    )}
                    {values.inputType === "URL_PULL" &&
                    (values.fileType === "live" || values.outputTemplateType === "reserved_channel") ? (
                      <>
                        <div className="form-group mb-1">
                          <Field
                            component={Checkbox}
                            onChange={(e) => {
                              setFieldValue("streamSelectionBitrateEnable", e.target.checked);
                              setFieldValue("streamSelectionBitrate", 0);
                            }}
                            value={values?.streamSelectionBitrateEnable}
                            name="streamSelectionBitrateEnable"
                            checked={values?.streamSelectionBitrateEnable}
                            className="me-2"
                          />
                          <label className="form-label mr-1">Stream Selection from bitrate</label>
                        </div>
                        {values.streamSelectionBitrateEnable && (
                          <div className="form-group ">
                            <Field
                              className="form-control"
                              name="streamSelectionBitrate"
                              type="number"
                              placeholder="Enter Bitrate"
                            />
                            {touched.streamSelectionBitrate && errors.streamSelectionBitrate && (
                              <div className="invalid-feedback">{errors.streamSelectionBitrate}</div>
                            )}
                          </div>
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                    {values?.outputTemplateType === "reserved_channel" &&
                      backupInputTypes.includes(values.inputType) && (
                        <div className="form-group mb-1">
                          <Field
                            component={Checkbox}
                            onChange={(e) => {
                              setFieldValue("isBackup", e.target.checked);
                            }}
                            value={values?.isBackup}
                            name="isBackup"
                            checked={values?.isBackup}
                            className="me-2"
                          />
                          <label className="form-label mr-1">Stream Backup</label>
                        </div>
                      )}
                    {values?.outputTemplateType === "reserved_channel" && (
                      <div className="form-group">
                        <label className="form-label">
                          Reserved Channel <span className="required">*</span>
                        </label>
                        <Field
                          className="custom-ant-select"
                          optionFilterProp="children"
                          name="reservedChannels"
                          showSearch
                          mode="multiple"
                          component={Select}
                          placeholder="Select channels"
                          value={values?.reservedChannels}
                          onChange={(value) => handleReservedChannels(setFieldValue, value, values)}
                        >
                          {inputType !== undefined && inputType !== ""
                            ? filteredReservedChannels.map((data, index) => {
                                return (
                                  <>
                                    <Option key={index} value={data.value}>
                                      {data.label}
                                    </Option>
                                  </>
                                );
                              })
                            : reservedChannel.map((data, index) => {
                                return (
                                  <>
                                    <Option key={index} value={data._id}>
                                      {data.channelName}
                                    </Option>
                                  </>
                                );
                              })}
                        </Field>
                        {touched.reservedChannels && errors.reservedChannels && (
                          <div className="invalid-feedback">{errors.reservedChannels}</div>
                        )}
                      </div>
                    )}
                    {values?.outputTemplateType == "medialive" && (
                      <div className="form-group">
                        <label className="form-label">
                          Media Live Region <span className="required">*</span>
                        </label>
                        <Field
                          className="custom-ant-select"
                          optionFilterProp="children"
                          name="mediaLiveRegion"
                          showSearch
                          onChange={(value) => setFieldValue("mediaLiveRegion", value)}
                          component={Select}
                          disabled={values?.fileType === "static"}
                          dropdownStyle={{ zIndex: 99999999 }}
                          value={values?.mediaLiveRegion}
                          defaultValue={initialValues?.mediaLiveRegion || "Select Media Region"}
                        >
                          {awsRegions.length &&
                            awsRegions.map((data, index) => {
                              return (
                                <>
                                  <Option key={index} value={data.value}>
                                    {data.label}
                                  </Option>
                                </>
                              );
                            })}
                        </Field>
                        {touched.mediaLiveRegion && errors.mediaLiveRegion && (
                          <div className="invalid-feedback">{errors.mediaLiveRegion}</div>
                        )}
                      </div>
                    )}
                    <div className="form-group">
                      <label className="form-label">
                        Source Region <span className="required">*</span>
                      </label>
                      <Field
                        className="custom-ant-select"
                        name="outputRegion"
                        showSearch
                        onChange={(value) => setFieldValue("outputRegion", value)}
                        component={Select}
                        value={values?.outputRegion}
                        disabled={values?.fileType === "static"}
                        dropdownStyle={{ zIndex: 99999999 }}
                        defaultValue={"Select Region"}
                      >
                        {mediaLiveTemplateRegions.length &&
                          mediaLiveTemplateRegions.map((data, index) => {
                            return (
                              <>
                                <Option key={index} value={data.value}>
                                  {data.label}
                                </Option>
                              </>
                            );
                          })}
                      </Field>
                      {touched.outputRegion && errors.outputRegion && (
                        <div className="invalid-feedback">{errors.outputRegion}</div>
                      )}
                    </div>

                    <div className="form-group">
                      <label className="form-label">
                        Media Live Storage <span className="required">*</span>
                      </label>
                      <Field
                        className="custom-ant-select"
                        name="mediaLiveStorageId"
                        showSearch
                        onChange={(value) => setFieldValue("mediaLiveStorageId", value)}
                        component={Select}
                        dropdownStyle={{ zIndex: 99999999 }}
                        defaultValue={initialValues?.mediaLiveStorageId || "Select Media Storage"}
                      >
                        {storageDetail.length &&
                          storageDetail.map((data, index) => {
                            return (
                              <>
                                <Option key={index} value={data._id}>
                                  {data.storage_name}
                                </Option>
                              </>
                            );
                          })}
                      </Field>
                      {touched.mediaLiveStorageId && errors.mediaLiveStorageId && (
                        <div className="invalid-feedback">{errors.mediaLiveStorageId}</div>
                      )}
                    </div>
                    {["medialive", "reserved_channel"].includes(values?.outputTemplateType) && (
                      <div className="form-group mb-1">
                        <Field
                          component={Checkbox}
                          onChange={(e) => {
                            setFieldValue(
                              "programDateTime",
                              e.target.checked ? PROGRAM_DATE_TIME.INCLUDE : PROGRAM_DATE_TIME.EXCLUDE,
                            );
                          }}
                          value={values?.programDateTime}
                          name="programDateTime"
                          checked={values?.programDateTime === PROGRAM_DATE_TIME.INCLUDE}
                          className="me-2"
                        />
                        <label className="form-label">Time code</label>
                      </div>
                    )}
                    <div className="form-group mb-1">
                      {values?.outputTemplateType === "medialive" && values?.inputType === "SRT_PULL" && (
                        <div className="form-group mb-1">
                          <Field
                            defaultChecked={false}
                            name="isSRTPassword"
                            onChange={(e) => {
                              setFieldValue("isSRTPassword", e.target.checked);
                            }}
                            checked={values?.isSRTPassword}
                            className="me-2"
                            component={Checkbox}
                          />
                          <label className="form-label">Password</label>
                        </div>
                      )}
                    </div>
                    <div className="form-group mb-1">
                      <Field
                        onChange={(e) => {
                          setFieldValue("isMultiAudio", e.target.checked);
                          setFieldValue("fillMultiAudioWithStream", true);
                          setFieldValue("languages", []);
                          setFieldValue("pid", []);
                          setSelectedAudioOptions([]);
                          setSelectedPids([]);
                          setMultiAudioOption("");
                        }}
                        defaultChecked={false}
                        name="isMultiAudio"
                        component={Checkbox}
                        checked={values?.isMultiAudio}
                        className="me-2"
                      />
                      <label className="form-label">Multi Audio</label>
                    </div>

                    {values?.isMultiAudio && (
                      <div className="form-group">
                        <Field
                          className="custom-ant-select"
                          name="fillMultiAudioWithStream"
                          onChange={(value) => {
                            setFieldValue("fillMultiAudioWithStream", value);
                            if (!value) {
                              setMultiAudioOption("iso");
                            } else {
                              setMultiAudioOption("");
                            }
                          }}
                          value={values?.fillMultiAudioWithStream}
                          component={Select}
                          dropdownStyle={{ zIndex: 99999999 }}
                          defaultValue={"Select Multi Audio Option"}
                        >
                          <Option value={false}>Audio selection</Option>
                          <Option value={true}>Audio selection during stream add</Option>
                        </Field>
                      </div>
                    )}

                    {values?.isMultiAudio && !values?.fillMultiAudioWithStream && multiAudioOption !== "" && (
                      <Field
                        name="multiAudioOption"
                        showSearch
                        optionFilterProp="children"
                        className="custom-ant-select"
                        style={{ textTransform: "capitalize" }}
                        value={multiAudioOption}
                        onChange={(value) => {
                          handleSelectChange(value);
                          setFieldValue("multiAudioOption", value);
                          setSelectedAudioOptions([]);
                          setSelectedPids([]);
                          setFieldValue("languages", []);
                          setFieldValue("pid", []);
                          setFieldValue("track", []);
                        }}
                        placeholder="Select Audio"
                        component={Select}
                      >
                        {["ISO", "PID", "TRACK"].map((option) => (
                          <Option key={option} value={option.toLowerCase()}>
                            {option}
                          </Option>
                        ))}
                      </Field>
                    )}
                    {multiAudioOption === "pid" && values?.isMultiAudio && !values?.fillMultiAudioWithStream && (
                      <div className="form-group">
                        <Field
                          name="pid"
                          className="form-control mt-3"
                          component={MultiInputField}
                          setSelectedOptions={(value) => {
                            setSelectedPids(value);
                            setFieldValue("pid", value);
                          }}
                          selectedOptions={selectedPids}
                          placeholder="Enter Pid's"
                        />
                        {touched.pid && errors.pid && <div className="invalid-feedback">{errors.pid}</div>}
                      </div>
                    )}
                    {multiAudioOption === "track" && values.isMultiAudio && !values.fillMultiAudioWithStream && (
                      <div className="form-group">
                        <Field
                          name="track"
                          className="form-control mt-3"
                          component={MultiInputField}
                          setSelectedOptions={(value) => {
                            setSelectedTracks(value);
                            setFieldValue("track", value);
                          }}
                          selectedOptions={selectedTracks}
                          placeholder="Enter Tracks"
                        />
                        {touched.track && errors.track && <div className="invalid-feedback">{errors.track}</div>}
                      </div>
                    )}
                    {multiAudioOption === "iso" && values?.isMultiAudio && !values?.fillMultiAudioWithStream && (
                      <div className="form-group">
                        <Field
                          name="languages"
                          selectedOptions={selectedAudioOptions}
                          setSelectetOptions={(value) => {
                            setSelectedAudioOptions(value);
                            setFieldValue("languages", value);
                          }}
                          intitialOptions={multiAudioOptions.map((audio) => {
                            return { label: audio?.English, value: audio["alpha3-b"] };
                          })}
                          component={MultiSelectWithRepeat}
                        />
                        {touched.languages && errors.languages && (
                          <div className="invalid-feedback">{errors.languages}</div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-center">
                      <button type="button" className="btn btn-white" onClick={closeModal}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Edit
                        {loder == false ? (
                          ""
                        ) : (
                          <Spin
                            size="large"
                            indicator={<LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />}
                            className="loader__full"
                          ></Spin>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  );
};

export default EditMediaLiveTemplate;
